/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2025, Zumper
 */

// stream token
export const CLEAR_STREAM_TOKEN = '@@nzr/messages/CLEAR_STREAM_TOKEN'
export const RECEIVE_STREAM_TOKEN_DATA = '@@nzr/messages/RECEIVE_STREAM_TOKEN_DATA'
export const RECEIVE_STREAM_TOKEN_RETRY = '@@nzr/messages/RECEIVE_STREAM_TOKEN_RETRY'
export const SET_STREAM_TOKEN_ERROR = '@@nzr/messages/SET_STREAM_TOKEN_ERROR'
export const SET_FEATURE_NOT_ENABLED = '@@nzr/messages/SET_FEATURE_NOT_ENABLED'

// stream unread counts
export const RECEIVE_STREAM_UNREAD_COUNTS = '@@nzr/messages/RECEIVE_STREAM_UNREAD_COUNTS'
// property details
export const RECEIVE_LISTING_DATA = '@@nzr/messages/RECEIVE_LISTING_DATA'
export const RECEIVE_BUILDING_DATA = '@@nzr/messages/RECEIVE_BUILDING_DATA'
// stream conversations
export const RECEIVE_STREAM_CONVERSATIONS_DATA = '@@nzr/messages/RECEIVE_STREAM_CONVERSATIONS_DATA'
export const RECEIVE_STREAM_CONVERSATIONS_ERROR =
  '@@nzr/messages/RECEIVE_STREAM_CONVERSATIONS_ERROR'
